import React from 'react';
import Popup from 'reactjs-popup';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

function BurgerIcon({ open, ...props }) {
  return (
    <div className={open ? 'burger-menu open' : 'burger-menu'} {...props}>
      <div className="bar1" key="b1" />
      <div className="bar2" key="b2" />
      <div className="bar3" key="b3" />
    </div>
  );
}

const StyledUl = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0;
`;

const StyledNavLink = styled(NavLink)`
  font-size: 22px;
  font-family: 'Ubuntu', sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  list-style: none;
  color: #2b2b2b;
  font-weight: 600;
  margin: 1em 0;
`;

function BurgerMenu({ close }) {
  return (
    <div className="menu">
      <StyledUl>
        <StyledNavLink to="/" activeClassName="active">
          Home
        </StyledNavLink>
        <StyledNavLink to="/about" activeClassName="active">
          About
        </StyledNavLink>
        <StyledNavLink to="/findce"> Find your CE</StyledNavLink>
        <StyledNavLink to="/resources">Resources</StyledNavLink>
        <StyledNavLink to="/corporate">Corporate</StyledNavLink>
        <StyledNavLink to="/signup">Create an account</StyledNavLink>
        <StyledNavLink to="/login">Login</StyledNavLink>
      </StyledUl>
    </div>
  );
}

const contentStyle = {
  background: 'rgba(255,255,255,0)',
  width: '100%',
  border: 'none',
};

export default function Hamburger() {
  return (
    <div>
      <Popup
        modal
        overlayStyle={{ background: 'rgba(255,255,255,0.98' }}
        contentStyle={contentStyle}
        closeOnDocumentClick={false}
        trigger={open => <BurgerIcon open={open} />}
      >
        {close => <BurgerMenu close={close} />}
      </Popup>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Burger.jsx